import { Select } from "antd"

interface Props {
  value?: string
  onChange?: (value?: string) => void
}

const APPROVAL_STATUS_OPTIONS = [
  { label: "Waiting Approval", value: "Waiting Approval" },
  { label: "Approved", value: "Approved" },
  { label: "Reject", value: "Reject" },
  { label: "Cancel", value: "Cancel" },
]

const SapApprovalStatusFilter = ({ value, onChange }: Props) => {
  return (
    <div style={{ display: "flex", justifyContent: "flex-end", margin: "24px 0 16px" }}>
      <Select
        allowClear
        placeholder="Filter approval status"
        value={value || undefined}
        options={APPROVAL_STATUS_OPTIONS}
        onChange={selectedValue => onChange?.(selectedValue || undefined)}
        style={{ width: "100%", maxWidth: 240 }}
      />
    </div>
  )
}

export default SapApprovalStatusFilter
